import React, { useState } from "react";
import ImageDropZone from "../components/ImageDropZone";
import { generateImagePDF } from "../services/pdfImageService";

const ImageUploader = () => {
	const [files, setFiles] = useState([]); 
	const [count, setCount] = useState(4);
	const [size, setSize] = useState("landscape");

    const handleCreatePdf = async () => {
        if (!files.length) return alert("No images selected");
        await generateImagePDF({files, count: count, size: size});
    };

	return (
		<div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
			<ImageDropZone onChange={setFiles}/>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div className="">
                    <label className="block text-sm font-medium text-gray-700">
                        Select Size
                    </label>
                    <select
                        value={size}
                        onChange={(e) => setSize(e.target.value)}
                        className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                        <option value="passport">Passport Size</option>
                        <option value="landscape">Passport Landscape (4)</option>
                        <option value="stamp">Stamp Size</option>
                        {/* <option value="2x4">2x4 in (NGO Combine Photo)</option> */}
                        <option value="ngo_combined">NGO Combine Photo</option>
                        <option value="2x2">2x2 in (Indian Visa Size)</option>
                        <option value="nid">NID (2 Image)</option>
                        <option value="nid_combined">NID Combined (1 Image)</option>
                        <option value="mrp">MRP Passport</option>
                        <option value="bordered">A4 with 0.5 Inch Border</option>
                        <option value="3R">3R Photo (Album Size)</option>
                        <option value="4R">4R Photo (4 Photo)</option>
                        <option value="6R">6R Photo (2 Photo)</option>
                    </select>
                </div>
                <div className="">
                    <label className="block text-sm font-medium text-gray-700">Image Count</label>
                    <input
                        type="number"
                        min={1}
                        value={count}
                        max={28}
                        onChange={(e) => setCount(e.target.value)}
                        className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Image Count"
                    />
                </div>
            </div>
            
            <button 
                className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                type="button"
                onClick={handleCreatePdf}>
                Create PDF
            </button>
		</div>
	);
};

export default ImageUploader;
